import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Validation from "../../../../hooks/Validation";
import { updateProfile } from "../../../../store/actions/adminAction";

import Popup from "../../../common/modal/Popup";
import Loader from "../../../common/loader/Loader";
import ApiResponsePopup from "../../../common/modal/ApiResponsePopup";

const formElements = [
  {
    key: "contactName",
    label: "Contact Name",
    placeHolder: "Enter contact person name",
    type: "text",
  },
  {
    key: "clientEmail",
    label: "Email",
    placeHolder: "Enter admin email",
    type: "text",
  },
];

const ManageProfile = (props) => {
  const { selectClient } = props;
 
  const [isUploading, setIsUploading] = useState(false);

  const [isShow, setIsShow] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);

  const [clientDetail, setClientDetail] = useState({
    location: null,
    contactName: null,
    clientEmail: null,
  });
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation({
      contactName: clientDetail?.contactName,
    });
  const dispatch = useDispatch();
  const {
    isRecordAdded,
    isRecordUpdated,
    error: apiError,
    isLoader,
  } = useSelector((state) => state.admin);

  useEffect(() => {
    if (selectClient === null) {
      setClientDetail({
        location: null,
        contactName: null,
        clientEmail: null,
        clientId: null,
      });
    } else {
      setClientDetail({
        clientId: selectClient._id,
        contactName: selectClient.contactName,
        clientEmail: selectClient.clientEmail,
      });
    }
  }, [selectClient]);

  const submitHandler = (e) => {
    e.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
   
    setIsUploading(true);
    let formData = new FormData();
    if (clientDetail.clientId) {
      formData.append("clientId", clientDetail?.clientId);
    }
    formData.append("contactName", clientDetail?.contactName);
    // formData.append("clientEmail", clientDetail?.clientEmail);
    
    if (!isError() && error !== null && isActionCalled) {
      dispatch(updateProfile(formData)).then(({ payload }) => {
        if (payload.success) {
          setIsUploading(true);
          hideHandler();
        } else {
          setIsShow(true);
        }
      });
      setIsActionCalled(false);
    } else {
    
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const hideHandler = () => {
    resetAllValidator();
    props.onHide();
    if (selectClient === null) {
      setClientDetail({
        contactName: null,
        clientEmail: null,
      });
    } else {
      setClientDetail({
        clientId: selectClient.clientId,
        contactName: selectClient.contactName,
        clientEmail: selectClient.clientEmail,
      });
    }
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  const { onHide, ...props1 } = props;

  return (
    <>
      <Popup
        {...props1}
        onHide={hideHandler}
        size="md"
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => hideHandler(e)}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler(e)}
            >
              {selectClient ? "Update" : "Add"}
            </Button>
          </>
        }
      >
        {isLoader && <Loader />}
        {formElements.map((element, i) => {
          return (
            (!selectClient || element.key !== "password") && (
              <Form.Group className="mb-4" controlId="formBasicEmail" key={i}>
                <Form.Label>
                  {element.label} <span className="required">*</span>
                </Form.Label>
                {element.type == "select" ? (
                  <Form.Select aria-label="Default select example">
                    <option value="">Select</option>
                    {element.options.map((item) => (
                      <option value={item}> {item} </option>
                    ))}
                  </Form.Select>
                ) : (
                  <>
                    <Form.Control
                      type={element.type}
                      name={element.key}
                      placeholder={element.placeHolder}
                      value={clientDetail && clientDetail[element.key]}
                      disabled={selectClient && element.key === "clientEmail"}
                      onChange={(e) => {
                        setClientDetail({
                          ...clientDetail,
                          [element.key]: e.target.value,
                        });
                        resetValidator(e.target.name);
                      }}
                      isInvalid={error && error[element.key]}
                    />
                    <Form.Control.Feedback type="invalid">
                      {error && error[element.key]}
                    </Form.Control.Feedback>
                  </>
                )}
              </Form.Group>
            )
          );
        })}

        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordAdded: isShow,
            title: selectClient ? "Update Admin" : "Add Admin",
            successMsg: successMessage,
            errorRes: apiError?.message,
          }}
        />
      </Popup>
    </>
  );
};

export default ManageProfile;
